import { render } from "./OrdersListOrder.vue?vue&type=template&id=43fe86d5"
import script from "./OrdersListOrder.vue?vue&type=script&lang=js"
export * from "./OrdersListOrder.vue?vue&type=script&lang=js"

import "./OrdersListOrder.vue?vue&type=style&index=0&id=43fe86d5&lang=less"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__